import VConsole from 'vconsole'

export default {
  data() {
    return {
      vConsole: null,
      clickCount: 0,
    }
  },
  mounted() {
    this.vConsole = new VConsole()
    this.vConsole.hideSwitch()
  },
  beforeDestroy() {
    this.vConsole.destroy()
  },
  methods: {
    openConsole() {
      this.clickCount += 1
      if (this.clickCount >= 10) {
        this.vConsole.showSwitch()
      }
    }
  }
}
